(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-discount-ui"]) return;
  try {
    
  (() => {
    const source = document.querySelector('[data-cart-discount-source]');
    if (!source) return;

    const mount = () => {
      const target = document.querySelector('[data-cart-footer]') || document.querySelector('.main-cart__summary');
      if (!target || target.querySelector('[data-cart-discount-form]')) return;
      const form = source.querySelector('[data-cart-discount-form]').cloneNode(true);
      const checkout = target.querySelector('.cart-drawer__checkout, .main-cart__checkout');
      target.insertBefore(form, checkout || null);
    };

    mount();
    document.addEventListener('cart:updated', mount);

    document.addEventListener('submit', (event) => {
      const form = event.target.closest('[data-cart-discount-form]');
      if (!form) return;
      event.preventDefault();

      const input = form.querySelector('input[name="discount"]');
      const message = form.querySelector('[data-discount-message]');
      const code = input?.value.trim();

      if (!code) {
        if (message) message.textContent = 'Enter a discount code.';
        return;
      }

      const redirect = encodeURIComponent(source.dataset.checkoutPath || '/checkout');
      window.location.assign(`${source.dataset.discountRoot}${encodeURIComponent(code)}?redirect=${redirect}`);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer-aroma"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-cart-drawer]');
    if (!root || root.dataset.initialised === 'true') return;
    root.dataset.initialised = 'true';

    const dialog = root.querySelector('[data-cart-dialog]');
    const overlay = root.querySelector('.cart-drawer__overlay');
    const status = root.querySelector('[data-cart-status]');
    const moneyFormat = root.dataset.moneyFormat;
    let noteTimer;

    const formatMoney = (cents) => {
      const amount = (Number(cents || 0) / 100).toFixed(2);
      return moneyFormat.replace(/\{\{\s*amount[^}]*\}\}/, amount);
    };

    const open = () => {
      if (!dialog.open) dialog.showModal();
      overlay.hidden = false;
      document.documentElement.style.overflow = 'hidden';
    };

    const close = () => {
      dialog.close();
      overlay.hidden = true;
      document.documentElement.style.overflow = '';
    };

    const render = (cart) => {
      const body = root.querySelector('[data-cart-body]');
      const footer = root.querySelector('[data-cart-footer]');
      root.querySelector('[data-cart-count]').textContent = `(${cart.item_count})`;
      document.querySelectorAll('[data-cart-count]').forEach((count) => {
        if (count.closest('[data-cart-drawer]')) return;
        count.textContent = cart.item_count;
        count.hidden = cart.item_count === 0;
      });

      if (!cart.items.length) {
        body.innerHTML = `<div class="cart-drawer__empty"><p>Your cart is empty.</p><a class="button button--primary" href="${window.Shopify?.routes?.root || '/'}collections/all">Start shopping</a></div>`;
        footer.hidden = true;
        return;
      }

      body.innerHTML = `<div class="cart-drawer__items">${cart.items.map((item, index) => `
        <article class="cart-drawer__item" data-cart-line="${index + 1}">
          <a class="cart-drawer__image-link" href="${item.url}">${item.image ? `<img class="cart-drawer__image" src="${item.image}&width=240" alt="${item.product_title.replace(/"/g, '&quot;')}">` : ''}</a>
          <div class="cart-drawer__item-info">
            <div><a class="cart-drawer__title" href="${item.url}">${item.product_title}</a>${item.variant_title ? `<p class="cart-drawer__variant">${item.variant_title}</p>` : ''}</div>
            <div class="cart-drawer__line-footer">
              <div class="cart-drawer__quantity"><button type="button" data-cart-quantity="${Math.max(0, item.quantity - 1)}" data-line="${index + 1}" aria-label="Decrease quantity">−</button><input type="number" min="0" value="${item.quantity}" data-cart-input data-line="${index + 1}" aria-label="Quantity"><button type="button" data-cart-quantity="${item.quantity + 1}" data-line="${index + 1}" aria-label="Increase quantity">+</button></div>
              <div class="cart-drawer__price">${item.original_line_price > item.final_line_price ? `<s>${formatMoney(item.original_line_price)}</s>` : ''}<span>${formatMoney(item.final_line_price)}</span></div>
            </div>
            <button class="cart-drawer__remove" type="button" data-cart-quantity="0" data-line="${index + 1}">Remove</button>
          </div>
        </article>`).join('')}</div>`;
      footer.hidden = false;
      root.querySelector('[data-cart-total]').textContent = formatMoney(cart.total_price);
      const note = root.querySelector('[data-cart-note]');
      if (note && document.activeElement !== note) note.value = cart.note || '';
    };

    const getCart = async () => {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Unable to load cart.');
      return response.json();
    };

    const updateLine = async (line, quantity) => {
      status.textContent = 'Updating cart…';
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line, quantity })
      });
      const cart = await response.json();
      if (!response.ok) throw new Error(cart.description || 'Unable to update cart.');
      render(cart); status.textContent = '';
    };

    root.addEventListener('click', (event) => {
      const closeButton = event.target.closest('[data-cart-close]');
      if (closeButton) { close(); return; }
      const quantityButton = event.target.closest('[data-cart-quantity]');
      if (quantityButton) updateLine(Number(quantityButton.dataset.line), Number(quantityButton.dataset.cartQuantity)).catch((error) => status.textContent = error.message);
    });

    root.addEventListener('change', (event) => {
      const input = event.target.closest('[data-cart-input]');
      if (input) updateLine(Number(input.dataset.line), Math.max(0, Number(input.value) || 0)).catch((error) => status.textContent = error.message);
    });

    root.addEventListener('input', (event) => {
      const note = event.target.closest('[data-cart-note]');
      if (!note) return;
      clearTimeout(noteTimer);
      noteTimer = setTimeout(async () => {
        await fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ note: note.value }) });
        status.textContent = 'Order note saved.';
      }, 500);
    });

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('a[href="/cart"], [data-cart-open]');
      if (!trigger || event.metaKey || event.ctrlKey) return;
      event.preventDefault();
      getCart().then((cart) => { render(cart); open(); }).catch(() => window.location.assign('/cart'));
    });

    document.addEventListener('cart:updated', (event) => {
      const cartPromise = event.detail?.cart ? Promise.resolve(event.detail.cart) : getCart();
      cartPromise.then((cart) => { render(cart); open(); });
    });

    dialog.addEventListener('cancel', (event) => { event.preventDefault(); close(); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-menu-controller"]) return;
  try {
    
  (() => {
    if (window.__aromaCartMenuController) return;
    window.__aromaCartMenuController = true;

    const cartRoot = () => window.Shopify?.routes?.root || '/';

    const openCartDrawer = async () => {
      const response = await fetch(`${cartRoot()}cart.js`, {
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) throw new Error('Unable to load the cart menu.');
      const cart = await response.json();
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
    };

    const removeCartPageLinks = () => {
      document.querySelectorAll('a[href="/cart"], a[href$="/cart"]').forEach((link) => {
        link.removeAttribute('href');
        link.setAttribute('role', 'button');
        link.setAttribute('tabindex', '0');
        link.dataset.cartMenuTrigger = 'true';
        if (link.classList.contains('cart-drawer__view-cart')) link.hidden = true;
      });
    };

    removeCartPageLinks();
    document.addEventListener('shopify:section:load', removeCartPageLinks);

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-cart-open], [data-cart-menu-trigger]');
      if (!trigger || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      openCartDrawer().catch((error) => window.alert(error.message));
    }, true);

    document.addEventListener('keydown', (event) => {
      const trigger = event.target.closest('[data-cart-menu-trigger]');
      if (!trigger || (event.key !== 'Enter' && event.key !== ' ')) return;
      event.preventDefault();
      openCartDrawer().catch((error) => window.alert(error.message));
    });

    document.addEventListener('submit', async (event) => {
      const form = event.target.closest('form[action*="/cart/add"]');
      if (!form || form.dataset.ajaxCart === 'false') return;

      event.preventDefault();
      const submitButton = form.querySelector('[type="submit"]');
      const originalLabel = submitButton?.textContent;

      if (submitButton) {
        submitButton.disabled = true;
        submitButton.textContent = 'Adding…';
      }

      try {
        const response = await fetch(`${cartRoot()}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'Unable to add this product.');

        await openCartDrawer();
      } catch (error) {
        document.dispatchEvent(new CustomEvent('cart:error', { detail: { message: error.message } }));
        window.alert(error.message);
      } finally {
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.textContent = originalLabel;
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const header = document.querySelector('[data-site-header]');
    if (!header) return;

    if (window.__aromaLenis) {
      window.__aromaLenis.destroy();
      window.__aromaLenis = null;
    }

    const searchDialog = header.querySelector('[data-search-dialog]');
    const searchInput = header.querySelector('[data-search-input]');
    const searchResults = header.querySelector('[data-search-results]');
    const searchTrigger = header.querySelector('[data-search-open]');
    const menuDialog = header.querySelector('[data-menu-dialog]');
    const menuTrigger = header.querySelector('[data-menu-open]');
    let lastScrollY = window.scrollY;
    let searchTimer;
    let searchController;

    const dialogIsOpen = () => searchDialog?.open || menuDialog?.open;

    const getScrollY = () => window.scrollY || document.documentElement.scrollTop || 0;

    const tick = () => {
      const currentScrollY = getScrollY();

      if (dialogIsOpen() || currentScrollY <= 80) {
        header.classList.remove('is-hidden');
      } else if (currentScrollY > lastScrollY && currentScrollY > 120) {
        header.classList.add('is-hidden');
      } else if (currentScrollY < lastScrollY) {
        header.classList.remove('is-hidden');
      }

      lastScrollY = currentScrollY;
      requestAnimationFrame(tick);
    };

    requestAnimationFrame(tick);

    const openSearch = () => {
      searchDialog.showModal();
      searchTrigger.setAttribute('aria-expanded', 'true');
      requestAnimationFrame(() => searchInput.focus());
    };
    const closeSearch = () => {
      searchDialog.close();
      searchTrigger.setAttribute('aria-expanded', 'false');
      searchResults.innerHTML = '';
      searchInput.setAttribute('aria-expanded', 'false');
    };
    const openMenu = () => {
      menuDialog.showModal();
      menuTrigger.setAttribute('aria-expanded', 'true');
    };
    const closeMenu = () => {
      menuDialog.close();
      menuTrigger.setAttribute('aria-expanded', 'false');
    };

    searchTrigger?.addEventListener('click', openSearch);
    menuTrigger?.addEventListener('click', openMenu);
    header.querySelector('[data-search-close]')?.addEventListener('click', closeSearch);
    header.querySelector('[data-menu-close]')?.addEventListener('click', closeMenu);
    searchDialog?.addEventListener('cancel', (event) => { event.preventDefault(); closeSearch(); });
    menuDialog?.addEventListener('cancel', (event) => { event.preventDefault(); closeMenu(); });

    searchInput?.addEventListener('input', () => {
      clearTimeout(searchTimer);
      const term = searchInput.value.trim();
      if (term.length < 2) {
        searchResults.innerHTML = '';
        searchInput.setAttribute('aria-expanded', 'false');
        return;
      }

      searchResults.innerHTML = '<p class="header-search__loading">Searching…</p>';
      searchTimer = setTimeout(async () => {
        searchController?.abort();
        searchController = new AbortController();
        const endpoint = new URL(header.dataset.predictiveSearchUrl, window.location.origin);
        endpoint.searchParams.set('q', term);
        endpoint.searchParams.set('resources[type]', 'product,collection,page');
        endpoint.searchParams.set('resources[limit]', '6');
        endpoint.searchParams.set('resources[options][unavailable_products]', 'last');
        endpoint.searchParams.set('section_id', header.dataset.searchSectionId);

        try {
          const response = await fetch(endpoint, { signal: searchController.signal });
          if (!response.ok) throw new Error('Search unavailable');
          const text = await response.text();
          const documentFragment = new DOMParser().parseFromString(text, 'text/html');
          const section = documentFragment.querySelector(`#shopify-section-${header.dataset.searchSectionId}`);
          searchResults.innerHTML = section?.innerHTML || '';
          searchInput.setAttribute('aria-expanded', searchResults.textContent.trim() ? 'true' : 'false');
        } catch (error) {
          if (error.name !== 'AbortError') searchResults.innerHTML = '<p>Search is temporarily unavailable.</p>';
        }
      }, 250);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-hero-slideshow]').forEach((slideshow) => {
    const slides = Array.from(slideshow.querySelectorAll('[data-slide]'));
    const dots = Array.from(slideshow.querySelectorAll('[data-slideshow-dot]'));
    const previousButton = slideshow.querySelector('[data-slideshow-previous]');
    const nextButton = slideshow.querySelector('[data-slideshow-next]');
    const autoplayEnabled = slideshow.dataset.autoplay === 'true';
    const autoplayInterval = Number(slideshow.dataset.interval) || 5000;
    let activeIndex = 0;
    let timer;

    if (slides.length < 2) return;

    const showSlide = (nextIndex) => {
      activeIndex = (nextIndex + slides.length) % slides.length;

      slides.forEach((slide, index) => {
        const isActive = index === activeIndex;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', String(!isActive));
      });

      dots.forEach((dot, index) => {
        const isActive = index === activeIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', String(isActive));
      });
    };

    const stopAutoplay = () => window.clearInterval(timer);
    const startAutoplay = () => {
      if (!autoplayEnabled || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      stopAutoplay();
      timer = window.setInterval(() => showSlide(activeIndex + 1), autoplayInterval);
    };

    previousButton?.addEventListener('click', () => {
      showSlide(activeIndex - 1);
      startAutoplay();
    });

    nextButton?.addEventListener('click', () => {
      showSlide(activeIndex + 1);
      startAutoplay();
    });

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        showSlide(Number(dot.dataset.slideshowDot));
        startAutoplay();
      });
    });

    slideshow.addEventListener('mouseenter', stopAutoplay);
    slideshow.addEventListener('mouseleave', startAutoplay);
    slideshow.addEventListener('focusin', stopAutoplay);
    slideshow.addEventListener('focusout', startAutoplay);

    startAutoplay();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  document.querySelectorAll('[data-collection-grid]').forEach((section) => {
    const toggle = section.querySelector('[data-filter-toggle]');
    const panel = section.querySelector('[data-filter-panel]');
    toggle?.addEventListener('click', () => {
      const isOpen = panel.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(isOpen));
    });

    section.querySelector('[data-sort-select]')?.addEventListener('change', (event) => event.currentTarget.form.submit());
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-aroma"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const variants = JSON.parse(root.querySelector('[data-product-json]')?.textContent || '[]');
    const form = root.querySelector('[data-product-form]');
    const variantInput = root.querySelector('[data-variant-id]');
    const price = root.querySelector('[data-product-price]');
    const mobilePrice = root.querySelector('[data-mobile-price]');
    const addButton = root.querySelector('[data-add-to-cart]');
    const addText = root.querySelector('[data-add-to-cart-text]');
    const mobileAdd = root.querySelector('[data-mobile-add]');
    const status = root.querySelector('[data-product-status]');
    const quantityInput = root.querySelector('[data-quantity-input]');

    const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: '{{ cart.currency.iso_code }}' }).format(cents / 100);

    root.querySelectorAll('[data-media-target]').forEach((button) => {
      button.addEventListener('click', () => {
        root.querySelectorAll('[data-product-media]').forEach((item) => {
          const active = item.dataset.productMedia === button.dataset.mediaTarget;
          item.hidden = !active;
          item.classList.toggle('is-active', active);
        });
        root.querySelectorAll('[data-media-target]').forEach((thumb) => {
          const active = thumb === button;
          thumb.classList.toggle('is-active', active);
          thumb.setAttribute('aria-pressed', String(active));
        });
      });
    });

    const updateVariant = () => {
      const values = Array.from(root.querySelectorAll('[data-option-position]:checked')).map((input) => input.value);
      const variant = variants.find((item) => item.options.every((option, index) => option === values[index])) || variants[0];
      if (!variant) return;
      variantInput.value = variant.id;
      const priceMarkup = variant.compare_at_price > variant.price
        ? `<span class="product-info__price-current">${money(variant.price)}</span><s class="product-info__price-compare">${money(variant.compare_at_price)}</s>`
        : `<span class="product-info__price-current">${money(variant.price)}</span>`;
      price.innerHTML = priceMarkup;
      mobilePrice.textContent = money(variant.price);
      addButton.disabled = !variant.available;
      mobileAdd.disabled = !variant.available;
      addText.textContent = variant.available ? 'Add to cart' : 'Sold out';
      mobileAdd.textContent = variant.available ? 'Add to cart' : 'Sold out';
      if (variant.featured_media) root.querySelector(`[data-media-target="${variant.featured_media.id}"]`)?.click();
      window.history.replaceState({}, '', `${window.location.pathname}?variant=${variant.id}`);
    };

    root.querySelectorAll('[data-option-position]').forEach((input) => input.addEventListener('change', updateVariant));
    root.querySelector('[data-quantity-minus]')?.addEventListener('click', () => quantityInput.value = Math.max(1, Number(quantityInput.value) - 1));
    root.querySelector('[data-quantity-plus]')?.addEventListener('click', () => quantityInput.value = Number(quantityInput.value) + 1);
    mobileAdd?.addEventListener('click', () => addButton?.click());

    form?.addEventListener('submit', async (event) => {
      event.preventDefault();
      addButton.disabled = true;
      status.textContent = 'Adding…';
      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: new FormData(form)
        });
        if (!response.ok) throw new Error('Unable to add this item.');
        status.textContent = 'Added to cart.';
        document.dispatchEvent(new CustomEvent('cart:updated'));
      } catch (error) {
        status.textContent = error.message;
      } finally {
        addButton.disabled = false;
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations-aroma"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('product-recommendations[data-url]').forEach(async (element) => {
    if (element.dataset.loaded === 'true') return;
    try {
      const response = await fetch(element.dataset.url);
      if (!response.ok) return;
      const html = document.createElement('div');
      html.innerHTML = await response.text();
      const replacement = html.querySelector('product-recommendations');
      if (replacement?.innerHTML.trim()) {
        element.innerHTML = replacement.innerHTML;
        element.dataset.loaded = 'true';
      }
    } catch (error) {
      console.error('Product recommendations failed to load.', error);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
